import ExternalLinksBaseHandler from '../external_links_base_handler';
import {MEMBERSHIP_POST_ACTIONS} from "../membership/external_links_membership_handler_consts";
import {POST_ACTIONS} from "../../../../events/post_actions";


/**
 * Handler for FYP
 */
class ExternalLinksForgotHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksForgotHandler';
    static HandlerName = 'forgot';

    /**
     * Overrides base class
     * @param postMessageData
     */
    executePostMessageAction(postMessageData) {
        switch (postMessageData.ActionId.toString()) {
            case '3':
                if (postMessageData.message === 'close') {
                    this.close();
                }
                break;
            case MEMBERSHIP_POST_ACTIONS.SHOW_LOGIN:
                //Close FYP window and open web login
                this.close(POST_ACTIONS.CLOSE);
                this._handleOpenWebLogin();
                break;

            default:
                // maybe should throw an Exception here
                break;
        }
    }


    getHandlerName() {
        return ExternalLinksForgotHandler.HandlerName;
    }

}

export default ExternalLinksForgotHandler;